export const AUTH_TOKEN = 'auth_token'
export const role_user = 'user_role'